/*
 * MONOCO Sticky CTA + バリアント選択ボトムシート
 * - 独自 fetch はしない。カート追加は既存フォーム（product_form_id）の submit に乗せる
 * - シート内の選択は本体 variant-selects の input を .click() して行う（状態は本体が唯一のソース）
 * - 表示制御は本体 ProductSubmitButton の IntersectionObserver
 */
(function () {
  function boot() {
    var bars = document.querySelectorAll('sticky-cta');
    for (var i = 0; i < bars.length; i++) init(bars[i]);
  }

  function init(bar) {
    var sectionId = bar.getAttribute('data-section-id');
    var isSingle = bar.getAttribute('data-single') === 'true';
    var productInfo = document.getElementById('MainProduct-' + sectionId);
    var mql = window.matchMedia('(max-width: 749px)');

    // ---- 表示制御：本体の追加ボタンが画面外に出たら表示（SPのみ） ----
    var target = document.getElementById('ProductSubmitButton-' + sectionId);
    if (target && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          for (var j = 0; j < entries.length; j++) {
            var entry = entries[j];
            // 本体ボタンが「画面より上」へスクロールされたときだけ表示。
            // まだ画面下（ファーストビューで未到達）の非表示状態では出さない。
            var off = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            bar.classList.toggle('is-visible', off && mql.matches);
          }
        },
        { threshold: 0 }
      );
      io.observe(target);
    }
    if (mql.addEventListener) {
      mql.addEventListener('change', function () {
        if (!mql.matches) bar.classList.remove('is-visible');
      });
    }

    // ---- シート ----
    var sheet = null;
    var matrix = [];
    var sheetId = bar.getAttribute('data-sheet-target');
    if (sheetId) {
      sheet = document.getElementById(sheetId);
      var mEl = sheet && sheet.querySelector('[data-sticky-matrix]');
      if (mEl) {
        try { matrix = JSON.parse(mEl.textContent) || []; } catch (e) { matrix = []; }
      }
    }

    function bodyInputs() {
      var vs = document.getElementById('variant-selects-' + sectionId);
      if (!vs) return [];
      return [].slice.call(vs.querySelectorAll('[data-option-index]'));
    }

    function currentOptions() {
      var opts = [];
      bodyInputs().forEach(function (el) {
        var on =
          (el.tagName === 'OPTION' && el.selected) ||
          (el.tagName === 'INPUT' && el.checked);
        if (on) opts[parseInt(el.getAttribute('data-option-index'), 10)] = el.getAttribute('data-value');
      });
      return opts;
    }

    function selectedVariant() {
      if (!matrix.length) return null;
      if (isSingle) return matrix[0];
      var opts = currentOptions();
      for (var k = 0; k < matrix.length; k++) {
        var mo = matrix[k].options;
        if (mo.length !== opts.length) continue;
        var same = true;
        for (var n = 0; n < mo.length; n++) {
          if (mo[n] !== opts[n]) { same = false; break; }
        }
        if (same) return matrix[k];
      }
      return null;
    }

    function syncUI() {
      var v = selectedVariant();
      if (!v) return;
      var sp = bar.querySelector('[data-sticky-price]');
      if (sp) sp.textContent = v.price;
      if (!sheet) return;
      var hp = sheet.querySelector('[data-sheet-price]');
      if (hp) hp.textContent = v.price;
      var th = sheet.querySelector('[data-sheet-thumb]');
      if (th && v.img) th.src = v.img;
      var rows = sheet.querySelectorAll('.variant-sheet__row');
      for (var r = 0; r < rows.length; r++) {
        rows[r].classList.toggle('is-selected', rows[r].getAttribute('data-variant-id') === String(v.id));
      }
      var submit = sheet.querySelector('[data-sheet-submit]');
      if (submit) submit.disabled = !v.available;
    }

    // 本体の選択変更に追従（product-info は差し替えられないので安定して委譲できる）
    if (productInfo) {
      productInfo.addEventListener('change', function () { setTimeout(syncUI, 0); });
    }

    // ---- 開閉 ----
    function openSheet() {
      if (!sheet) return;
      sheet.hidden = false;
      document.documentElement.classList.add('sticky-sheet-open');
      // reflow を挟んでトランジションを効かせる
      void sheet.offsetWidth;
      sheet.classList.add('is-open');
      syncUI();
    }

    function closeSheet() {
      if (!sheet) return;
      sheet.classList.remove('is-open');
      document.documentElement.classList.remove('sticky-sheet-open');
      var done = function () {
        if (!sheet.classList.contains('is-open')) sheet.hidden = true;
        sheet.removeEventListener('transitionend', done);
      };
      sheet.addEventListener('transitionend', done);
      setTimeout(done, 350);
    }

    var openBtn = bar.querySelector('[data-open-sheet]');
    if (openBtn) openBtn.addEventListener('click', openSheet);

    if (sheet) {
      var closers = sheet.querySelectorAll('[data-close-sheet]');
      for (var c = 0; c < closers.length; c++) closers[c].addEventListener('click', closeSheet);

      document.addEventListener('keydown', function (e) {
        if ((e.key === 'Escape' || e.keyCode === 27) && !sheet.hidden) closeSheet();
      });

      // 行タップ → 本体 variant picker を操作（独自状態は持たない）
      var rows = sheet.querySelectorAll('.variant-sheet__row');
      for (var ri = 0; ri < rows.length; ri++) {
        (function (row) {
          if (row.disabled) return;
          row.addEventListener('click', function () {
            var id = row.getAttribute('data-variant-id');
            var entry = null;
            for (var m = 0; m < matrix.length; m++) {
              if (String(matrix[m].id) === id) { entry = matrix[m]; break; }
            }
            if (!entry) return;
            var inputs = bodyInputs();
            // オプション軸ごとに、本体の対応 input を click（同一tick内なので差し替え前に完了）
            entry.options.forEach(function (val, idx) {
              for (var q = 0; q < inputs.length; q++) {
                var el = inputs[q];
                if (parseInt(el.getAttribute('data-option-index'), 10) !== idx) continue;
                if (el.getAttribute('data-value') !== val) continue;
                var checked =
                  (el.tagName === 'INPUT' && el.checked) ||
                  (el.tagName === 'OPTION' && el.selected);
                if (checked) break;
                if (el.tagName === 'OPTION') {
                  el.selected = true;
                  var sel = el.closest('select');
                  if (sel) sel.dispatchEvent(new Event('change', { bubbles: true }));
                } else {
                  el.click();
                }
                break;
              }
            });
            setTimeout(syncUI, 0);
          });
        })(rows[ri]);
      }

      // フッター「カートに追加」= 既存フォーム submit。シートは閉じてカートを見せる
      var submit = sheet.querySelector('[data-sheet-submit]');
      if (submit) {
        submit.addEventListener('click', function () {
          if (submit.disabled) return;
          setTimeout(closeSheet, 0);
        });
      }
    }

    syncUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
